// This is just for the Loading or Error Selector
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";

// Use these for Actions
export const GET_NOTIFICATIONS_REQUEST = "GET_NOTIFICATIONS_REQUEST";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_ERROR = "GET_NOTIFICATIONS_ERROR";
